module.exports = __webpack_public_path__ + "static/img/nx_box.b8533f21.png";